{
  "defaultTitle": "Tidak dapat daftar masuk",
  "defaultMessage": "Sila sahkan maklumat dengan penghantar tugas anda atau hubungi gudang",
  "backToHomescreen": "Kembali ke skrin utama",
  "hideErrorLog": "SEMBUNYIKAN LOG RALAT",
  "viewErrorLog": "LIHAT LOG RALAT",
  "errorLogMessageLabel": "Mesej:",
  "errorLogStatusLabel": "Kod Status:",
  "unknown": "Tidak diketahui"
}
